import { styled } from '@mui/material/styles';
import { Box, Typography, OutlinedInput } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

export const SecondaryTextBox = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary
}));

export const DisplayNameInfoTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(-1),
  marginBottom: theme.spacing(2)
}));

export const PolicyAgreementStack = styled('div')(({ theme }) => ({
  color: theme.palette.text.secondary
}));

export const SubmitButton = styled(LoadingButton)(({ theme }) => ({
  marginTop: theme.spacing(4)
})); 